module.exports = __webpack_public_path__ + "static/img/commission_share.84f64107.jpg";